// src/app/TiroirMenu.jsx — LE MENU ☰ DE L'ADMIN AU TÉLÉPHONE (maquette NEST
// v677, relevé du tiroir) : Au quotidien, Mon parc, Réglages en pied. La
// pastille du ☰ additionne ce que la barre du bas ne montre pas. Le tiroir
// vit dans `body` : la barre du haut est collante et ferait écran dessous.

import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import useEtroit from '../lib/useEtroit'
import { LOGO_NEST } from '../assets/logo-nest'

const CSS = `
.nmenu-b{position:relative;width:38px;height:38px;border:0;border-radius:10px;background:transparent;font-size:18px;line-height:1;color:#5E6A66;cursor:pointer;flex-shrink:0}
.nmenu-b i{position:absolute;top:-4px;right:-4px;min-width:16px;height:16px;border-radius:99px;background:#7A2E6E;color:#fff;font-size:9.5px;font-style:normal;font-weight:700;display:grid;place-items:center;padding:0 4px;box-sizing:content-box}
.nmenu-v{position:fixed;inset:0;background:rgba(23,33,30,.45);z-index:900;border:0;padding:0}
.nmenu{position:fixed;top:0;bottom:0;left:0;width:300px;max-width:84%;background:#F4F6F5;z-index:901;display:flex;flex-direction:column;padding:14px 12px 18px;box-sizing:border-box;overflow-y:auto;box-shadow:8px 0 30px rgba(20,30,42,.22)}
.nmenu-t{display:flex;align-items:center;gap:10px;padding:4px 8px 12px;font-weight:600;font-size:15px;letter-spacing:.04em;color:#17211E}
.nmenu-x{margin-left:auto;width:34px;height:34px;border:0;border-radius:9px;background:transparent;font-size:18px;color:#17211E;cursor:pointer}
.nmenu-s{font-size:10px;font-weight:600;letter-spacing:.08em;color:#6B7672;padding:10px 12px 6px;text-transform:uppercase}
.nmenu-e{position:relative;display:flex;align-items:center;gap:12px;width:100%;min-height:44px;padding:0 12px;border:0;border-radius:10px;background:transparent;font-size:13.5px;color:#17211E;cursor:pointer;text-align:left}
.nmenu-e[aria-current]{background:#E8F3EE;font-weight:600}
.nmenu-e[aria-current]::before{content:"";position:absolute;left:-12px;top:9px;bottom:9px;width:3px;border-radius:0 3px 3px 0;background:#17211E}
.nmenu-e span{flex:1}
.nmenu-e b{min-width:16px;height:18px;padding:0 5px;border-radius:9px;background:#143D34;color:#fff;font-size:10.5px;font-weight:700;display:grid;place-items:center}
.nmenu-p{margin-top:auto;display:flex;align-items:center;gap:10px;width:100%;min-height:52px;padding:8px 10px;border:1px solid #E6EAE8;border-radius:14px;background:#fff;cursor:pointer;font-size:12.5px;color:#17211E;text-align:left}
.nmenu-p em{width:32px;height:32px;border-radius:9px;background:#143D34;color:#fff;font-style:normal;font-size:11px;font-weight:700;display:grid;place-items:center;flex-shrink:0}
`

function Entree({ c, actif, n, onClick }) {
  const Icone = c.Icone
  return (
    <button type="button" className="nmenu-e" data-testid={`tiroir-${c.id}`}
      aria-current={actif ? 'page' : undefined} onClick={onClick}>
      {Icone ? <Icone size={19} strokeWidth={1.8} aria-hidden="true" /> : null}
      <span>{c.label}</span>
      {n > 0 ? <b>{n}</b> : null}
    </button>
  )
}

export default function TiroirMenu({ categories, activeId, onChoisir, onReglages, badges = {} }) {
  const etroit = useEtroit()
  const [ouvert, setOuvert] = useState(false)
  useEffect(() => { if (!etroit) setOuvert(false) }, [etroit])
  useEffect(() => {
    if (!ouvert) return undefined
    const f = (e) => { if (e.key === 'Escape') setOuvert(false) }
    document.addEventListener('keydown', f)
    return () => document.removeEventListener('keydown', f)
  }, [ouvert])
  if (!etroit) return null
  const quotidien = categories.filter((c) => !c.dansTiroir)
  const parc = categories.filter((c) => c.dansTiroir)
  const caches = parc.reduce((n, c) => n + (badges[c.id] || 0), 0)
  const aller = (id) => { setOuvert(false); onChoisir(id) }
  const entree = (c) => (
    <Entree key={c.id} c={c} actif={c.id === activeId} n={badges[c.id] || 0} onClick={() => aller(c.id)} />
  )
  return (
    <>
      <style>{CSS}</style>
      <button type="button" className="nmenu-b" data-testid="tiroir-ouvrir"
        aria-label="Ouvrir le menu" aria-expanded={ouvert} onClick={() => setOuvert(true)}>
        ☰
        {caches > 0 ? <i data-testid="tiroir-pastille">{caches}</i> : null}
      </button>
      {ouvert ? createPortal(
        <>
          <button type="button" className="nmenu-v" aria-label="Fermer le menu" onClick={() => setOuvert(false)} />
          <nav className="nmenu" data-testid="tiroir-menu" aria-label="Menu">
            <div className="nmenu-t">
              <img src={LOGO_NEST} alt="" width="38" height="38" />
              NEST
              <button type="button" className="nmenu-x" aria-label="Fermer le menu" onClick={() => setOuvert(false)}>×</button>
            </div>
            <div className="nmenu-s">Au quotidien</div>
            {quotidien.map(entree)}
            <div className="nmenu-s">Mon parc</div>
            {parc.map(entree)}
            <button type="button" className="nmenu-p" data-testid="tiroir-reglages"
              onClick={() => { setOuvert(false); onReglages() }}>
              <em aria-hidden="true">FZ</em> Réglages
            </button>
          </nav>
        </>,
        document.body,
      ) : null}
    </>
  )
}
